import DashboardService from 'services/DashboardService';
import CurrentStudentService from 'services/CurrentStudentService';
import CardService from 'services/CardService';
import ConfigsService from 'services/ConfigsService';

function getBills(type, state, resolve) {
  return DashboardService[`get${type}Bills`](state.currentBilling.id).then(resolve);
}

export default {
  loadStudent({ state, commit }) {
    return CurrentStudentService.loadStudent(state.billing).then((student) => {
      commit('setStudent', student);
    });
  },

  loadBillings({ commit }) {
    return DashboardService.getBillings().then((billings) => {
      commit('setBillings', billings);
    });
  },

  loadCurrentContract({ state, commit }) {
    return DashboardService.getCurrentContract(state.currentBilling.id).then((contract) => {
      commit('setCurrentContract', contract);
    });
  },

  loadStudentCards({ commit }) {
    return CardService.getStudentCards().then((cards) => {
      commit('setStudentCards', cards);
    });
  },

  loadCurrentBill({ state, commit }) {
    state.loadingCurrentBill = true;
    return DashboardService.getCurrentBill(state.currentBilling.id).then((bill) => {
      commit('setCurrentBill', bill);
    });
  },

  loadOverdueBills({ state, commit }) {
    return getBills('Overdue', state, (bills) => commit('setOverdueBills', bills));
  },

  loadNotPaidBills({ state, commit }) {
    return getBills('NotPaid', state, (bills) => commit('setNotPaidBills', bills));
  },

  loadNextUnpaidBill({ state, commit }) {
    return getBills('NotPaid', state, (bills) => commit('setNextUnpaidBill', bills[0]));
  },

  loadConfigs({ commit }) {
    return ConfigsService.getConfigs().then(({ data }) => {
      commit('setConfigs', data);
    });
  },

  loadReenrollment({ state, commit }) {
    return DashboardService.getReenrollment(state.currentBilling.id).then((reenrollment) => {
      commit('setReenrollment', reenrollment);

      return reenrollment;
    });
  },
};
